import { unauthenticatedFetch } from "../../api/request";

export default async function publicResetPassword(secret: string, password: string) {
    const url = '/public/v5/users/account/resetPassword';
    return await unauthenticatedFetch(url, {
        method: 'POST',
        body: JSON.stringify({
            secret,
            password,
        }),
    });
}
